import { createLogger } from '@moniebook-web/utils';

export const logger = createLogger('host-ui');
